import { BadgeCheck } from 'lucide-react';
import Avatar from '../ui/Avatar';
import CountBadge from '../ui/CountBadge';
import { formatRelativeDate } from '../../lib/format';

/**
 * A single inbox row, rendered from the real conversations payload.
 *
 * Unread styling is driven by `unreadCount`, which the server computes by
 * summing unread messages across every thread with this counterparty.
 */
export default function ConversationItem({ conversation, isActive, onSelect }) {
  const {
    id,
    name,
    username,
    avatarUrl,
    lastMessage,
    lastMessageAt,
    unreadCount,
    unread,
    online,
    verified,
    officialTitle,
  } = conversation;

  return (
    <li>
      <button
        type="button"
        onClick={() => onSelect(id)}
        aria-current={isActive ? 'true' : undefined}
        className={`z2-row-hover flex w-full items-start gap-3 rounded-xl px-3 py-3 text-left lg:py-2.5 ${
          isActive
            ? 'bg-brand-soft shadow-[inset_3px_0_0_0_var(--color-brand-600)]'
            : 'hover:bg-surface-3'
        }`}
      >
        <Avatar name={name} src={avatarUrl} online={online} />

        <span className="min-w-0 flex-1">
          <span className="flex items-center gap-1.5">
            <span
              className={`truncate text-[13.5px] text-ink ${unread ? 'font-semibold' : 'font-medium'}`}
            >
              {name}
            </span>
            {officialTitle && (
              <span
                className="shrink-0 rounded-full px-1.5 py-0.5 text-[9.5px] font-bold text-white"
                style={{ backgroundColor: '#7c3aed' }}
              >
                {officialTitle}
              </span>
            )}
            {verified && (
              <BadgeCheck
                size={13}
                aria-label="Verified seller"
                className="shrink-0 text-accent"
              />
            )}
            <span className="ml-auto shrink-0 text-[11px] text-ink-3 tabular-nums">
              {formatRelativeDate(lastMessageAt)}
            </span>
          </span>

          <span className="mt-0.5 flex items-start gap-2">
            <span
              className={`line-clamp-2 flex-1 text-[12.5px] leading-snug ${
                unread ? 'text-ink-2' : 'text-ink-3'
              }`}
            >
              {lastMessage}
            </span>
            {unread && (
              <CountBadge value={unreadCount} tone="brand" className="mt-px shrink-0" />
            )}
          </span>

          {username && (
            <span className="mt-0.5 block truncate text-[11px] text-ink-3">@{username}</span>
          )}
        </span>
      </button>
    </li>
  );
}
